// React Imports
import * as React from 'react';
import {useContext, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Divider from "@mui/material/Divider";
import { Stack, Tooltip} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';

// App Imports
import ContractDrilldownCSFGrid from "./ContractDrilldownCSF/ContractDrilldownCSFGrid";
import ContractDrilldownCDPGrid, {CDPcontext} from "./ContractDrilldownCDP/ContractDrilldownCDPGrid";
import ContractDrilldownCSGrid from "./ContractDrilldownCS/ContractDrilldownCSGrid";
import ContractDrilldownCDPVFGrid from "./ContractDrilldownCDPVF/ContractDrilldownCDPVFGrid";
import ContractSectionDrawer from "../ContractSection/ContractSectionDrawer";
import ContractDataPointDrawer from "../ContractDataPoint/ContractDataPointDrawer";
import ContractDataPointValueFilterDrawer from "../ContractDataPointValueFilter/ContractDataPointValueFilterDrawer";
import CDPVGrid from "./ContractDrilldownCDPV/contractDrilldownCDPVGrid";
import {changeContract} from "../Contract/contractSlice";
import ContractDescriptionPanel from "./ContractDescriptionPanel";
import Typography from "@mui/material/Typography";
import ContractStatsPanel from "./ContractStatsPanel";
import CrudSnackbar from "../CommonComponents/CrudSnackbar";
import QueryFinancialsGridVersionWide from "./ContractDrilldownCS/Helpers/LineItems/QueryFinancialsGridVersionWide";
import HelperPanel from "./ContractDrilldownCS/Helpers/HelperPanel";
import {changeContractDrilldown} from "./contractDrilldownSlice";
import DynamicHelperPanel from "./ContractDrilldownCS/Helpers/DynamicHelper/DynamicHelperPanel";
import RefreshIcon from "@mui/icons-material/Refresh";
import {changeContractSection} from "../ContractSection/contractSectionSlice";
import {changeContractDataPoint} from "../ContractDataPoint/contractDataPointSlice";
import {changeContractSectionFilter} from "../ContractSectionFilter/contractSectionFilterSlice";


// main function
 export default function ContractDrilldownFrame( {onCsList, onCsfList, onCdpList, onCdpvList, onCdpvfList, onVocabularyList, onMarketList}) {

    // ****************** BEGIN STATES ****************************

    const [contractSectionIdP, setContractSectionIdP] = useState([]);
    const [showCDPVDrawerTop,setShowCDPVDrawerTop] = useState(false);
    const [selectedCDPTop,setSelectedCDPTop] = useState([]);
    const [contractDataPointId,setContractDataPointId] = useState([]);

     const selectorContractId = useSelector((state) => state.contractSlc.value.id);


    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorModule = useSelector((state) => state.contractSlc.value.module);
    const selectorContractAPI = useSelector((state) => state.contractSlc.value.contractGridAPI);
    const selectorCdpvfGrid = useSelector((state) => state.contractDrilldownSlcCDPVF.value.cdpvfGridState);
    const selectorCdpvfDrawerContext = useSelector((state) => state.contractDrilldownSlcCDPVF.value.cdpvfDrawerContext);
    const selectorCdpDrawerState =  useSelector((state) => state.contractDataPointSlc.value.cdpDrawerState);
     const selectorHelperState =  useSelector((state) => state.contractDrilldownSlc.value.helperState);
     const selectorDynamicHelperState =  useSelector((state) => state.contractDrilldownSlc.value.dynamicHelperState);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    // useEffect(() => {
    //     if (props.selectorContractId !== setselectorContractId()) {
    //         setselectorContractId(props.selectorContractId);
    //         console.log("this is my contractId");
    //         console.log(props.selectorContractId);
    //         console.log(selectorContractId);
    //     };
    //     {
    //         setContractName(props.contractName);
    //         console.log("this is my contractName");
    //         console.log(props.contractName);
    //         console.log(contractName);
    //     }
    //     if (props.contractDescription !== setContractDescription()) {
    //         setContractDescription(props.contractDescription);
    //         console.log("this is my contractDescription");
    //         console.log(props.contractDescription);
    //         console.log(contractDescription);
    //     };
    // }, [props.selectorContractId]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    const handleBackButton = () => {
    if(selectorContractAPI === 'CBA'){
        dispatchData(changeContract({residualsTabsIndex: 0,contractGridAPI: "CBA", contractGridVisible: true,
            contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
            module: selectorModule,residualsTabsVisible: true,participationsTabsVisible: false,
            royaltiesTabsVisible: false}));}
        if(selectorContractAPI === 'Sideletter'){
            dispatchData(changeContract({residualsTabsIndex: 1,contractGridAPI: "Sideletter", contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                module: selectorModule,residualsTabsVisible: true,participationsTabsVisible: false,
                royaltiesTabsVisible: false}));}
        if(selectorContractAPI === 'SideletterTemplate'){
            dispatchData(changeContract({residualsTabsIndex: 2,contractGridAPI: "SideletterTemplate", contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                module: selectorModule,residualsTabsVisible: true,participationsTabsVisible: false,
                royaltiesTabsVisible: false}));}
        if(selectorContractAPI === 'DeterminationLetter'){
            dispatchData(changeContract({residualsTabsIndex: 3,contractGridAPI: "DeterminationLetter", contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                module: selectorModule,residualsTabsVisible: true,participationsTabsVisible: false,
                royaltiesTabsVisible: false}));}
        if(selectorContractAPI === 'ResPre' || selectorContractAPI === 'ResPost'|| selectorContractAPI === 'ResSystem'  ){
            dispatchData(changeContract({residualsTabsIndex: 4,contractGridAPI: selectorContractAPI, contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: true, contractSearchVisible: false,
                module: selectorModule,residualsTabsVisible: false,participationsTabsVisible: false,
                royaltiesTabsVisible: false}));}
    else if (selectorContractAPI === 'PartsStandards'){
        dispatchData(changeContract({participationsTabsIndex: 0,contractGridAPI: "PartsStandards", contractGridVisible: true,
            contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
            module: selectorModule,residualsTabsVisible: false,participationsTabsVisible: true,
            royaltiesTabsVisible: false}));}
        else if (selectorContractAPI === 'PartsAbstracts'){
            dispatchData(changeContract({participationsTabsIndex: 1,contractGridAPI: "PartsAbstracts", contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                module: selectorModule,residualsTabsVisible: false,participationsTabsVisible: true,
                royaltiesTabsVisible: false}));}
        else if (selectorContractAPI === 'PartsRiders'){
            dispatchData(changeContract({participationsTabsIndex: 2,contractGridAPI: "PartsRiders", contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                module: selectorModule,residualsTabsVisible: false,participationsTabsVisible: true,
                royaltiesTabsVisible: false}));}
        else if (selectorContractAPI === 'Branches'){
            dispatchData(changeContract({participationsTabsIndex: 5,contractGridAPI: "Branches", contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                module: selectorModule,residualsTabsVisible: false,participationsTabsVisible: true,
                royaltiesTabsVisible: false}));}
        else if (selectorContractAPI === 'PartsDocuments'){
            dispatchData(changeContract({participationsTabsIndex: 3,contractGridAPI: "PartsDocuments", contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                module: selectorModule,residualsTabsVisible: false,participationsTabsVisible: true,
                royaltiesTabsVisible: false}));}
        else if (selectorContractAPI === 'PartsPackages'){
            dispatchData(changeContract({participationsTabsIndex: 4,contractGridAPI: "PartsPackages", contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                module: selectorModule,residualsTabsVisible: false,participationsTabsVisible: true,
                royaltiesTabsVisible: false}));}
        if(selectorContractAPI === 'PartsPre' || selectorContractAPI === 'PartsPost'|| selectorContractAPI === 'PartsSystem'  ){
            dispatchData(changeContract({participationsTabsIndex: 5,contractGridAPI: selectorContractAPI, contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: true, contractSearchVisible: false,
                module: selectorModule,residualsTabsVisible: false,participationsTabsVisible: false,
                royaltiesTabsVisible: false}));}
        // else if (selectorModule === 'Participations'){
        //     dispatchData(changeContract({contractGridAPI: "PartsStandards", contractGridVisible: true,
        //         contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
        //         module: selectorModule,residualsTabsVisible: false,participationsTabsVisible: true,
        //         royaltiesTabsVisible: false}));}
    else if (selectorContractAPI === 'RoyalStandards'){
        dispatchData(changeContract({contractGridAPI: "RoyalStandards", contractGridVisible: true,
            contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
            module: selectorModule,residualsTabsVisible: false,participationsTabsVisible: false,
        royaltiesTabsVisible: true}));}
        else if (selectorContractAPI === 'RoyalAbstracts'){
            dispatchData(changeContract({contractGridAPI: "RoyalAbstracts", contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                module: selectorModule,residualsTabsVisible: false,participationsTabsVisible: false,
                royaltiesTabsVisible: true}));}
        else if (selectorContractAPI === 'Dashboards'){
            dispatchData(changeContract({contractGridAPI: "Dashboards", contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                module: 'Dashboards' ,residualsTabsVisible: false,participationsTabsVisible: false,
                royaltiesTabsVisible: false}));}
        dispatchData(changeContractDrilldown({helperState: false}));
    }

    // *************** END CONTROLS *******************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <div>
                    {selectorCdpvfGrid &&
                    <ContractDrilldownCDPVFGrid/>
                }
            </div>
            <div>
                {selectorCdpvfDrawerContext === "cdpGrid" &&
                <ContractDataPointValueFilterDrawer/>}
            </div>
            <div>
            {useSelector((state) => state.contractDrilldownSlcCDPV.value.cdpvGridState)  && <CDPVGrid/>}
            </div>

            <Box
                sx={{

                    height: 80,
                    paddingLeft: 3
                }}>


                {/*// *************************** BEGIN CONTRACT TITLE ***************************************/}
                {/*// ****************************************************************************************/}

                {/*<Stack direction="row" spacing={2}>*/}
                {/*    <Box>*/}
                {/*        <IconButton style={{cursor:'pointer'}} sx={{mr: 1, verticalAlign: 'center'}} onClick={handleBackButton}>*/}
                {/*            <ArrowBackIosNewRoundedIcon />*/}
                {/*        </IconButton>*/}
                {/*    </Box>*/}
                {/*    <Box sx={{pt: 2, pb: 0,verticalAlign: 'center'}}>*/}
                {/*        <Tooltip enterDelay={1000} title={<span style={{whiteSpace: 'pre-line'}}>*/}
                {/*            {"id: " + useSelector((state) => state.contractDrilldownSlc.value.id) +*/}
                {/*                "\ndescription: " + useSelector((state) => state.contractDrilldownSlc.value.description)*/}
                {/*             }                    </span>} style={{cursor:'pointer'}} >*/}
                {/*        <h2>{useSelector((state) => state.contractDrilldownSlc.value.name)} </h2>*/}
                {/*        </Tooltip>*/}

                {/*    </Box>*/}

                {/*    /!*<Box sx={{pt: 3, pb: 2,verticalAlign: 'bottom'}} style={{cursor:'pointer'}}>*!/*/}

                {/*    /!*</Box>*!/*/}

                {/*</Stack>*/}


                <Stack direction="row" spacing={2} alignItems="center">
                    <IconButton
                        onClick={handleBackButton}
                        color="primary"
                        size="medium"
                        sx={{ cursor: 'pointer' }}
                    >
                        <ArrowBackIosNewRoundedIcon />
                    </IconButton>

                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={<span style={{whiteSpace: 'pre-line'}}>
                            {"id: " + useSelector((state) => state.contractDrilldownSlc.value.id) +
                                "\ndescription: " + useSelector((state) => state.contractDrilldownSlc.value.description)
                            }                    </span>} style={{cursor:'pointer'}} >
                        <Typography variant="h5" component="h2" sx={{ cursor: 'pointer', fontWeight: 'bold' }}>
                            {useSelector((state) => state.contractDrilldownSlc.value.name)}
                        </Typography>
                    </Tooltip>
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Refresh contract section grid"}>
                    <RefreshIcon  color={'primary'}  style={{cursor:'pointer', size: 'large' }}
                                  onClick={() => {dispatchData(changeContractSection({csGridRefresh: true}));
                                      dispatchData(changeContractDataPoint({ cdpGridRefresh: true }));
                                      dispatchData(changeContractSectionFilter({csfGridRefresh: true}));
                                  }}
                    />
                    </Tooltip>
                </Stack>

            </Box>
            <Divider/>

            {/*// *************************** END CONTRACT TITLE ***************************************/}
            {/*// ****************************************************************************************/}

            <Box
                sx={{
                    // width: 600,
                    height: 10,
                    paddingLeft: 3
                }}/>

            {/*// *************************** BEGIN BODY *************************************************/}
            {/*// ****************************************************************************************/}


            {/*< Stack direction="row" spacing={2}>*/}
            <Stack direction="row" sx={{ width: '100%', height: 800 }}>

                {/*<ContractSectionDrawer/>*/}

                {/*// *************************** BEGIN LEFT PANEL *******************************************/}
                {/*// ****************************************************************************************/}

                <Box
                    sx={{

                        width: 800,
                        height: 800,
                        flexShrink: 0,
                        backgroundColor: 'primary.white',
                    }}
                >
                    {/*this pass... = is part of having the child component pass the data with its exported function*/}
                    <ContractDrilldownCSGrid
                        // passContractSectionIdP={setContractSectionIdP}
                        // selectorContractId = {selectorContractId}

                        // contractId = {contractId}

                    />

                </Box>


                {/*// *************************** END LEFT PANEL *******************************************/}
                {/*// ****************************************************************************************/}


                {/*// *************************** BEGIN RIGHT PANEL *******************************************/}
                {/*// ****************************************************************************************/}
                {useSelector((state) => state.contractSectionSlc.value.id) === 0 &&

                        <Box                sx={{
                            width: 900,
                            height: 800,
                            flexGrow: 1,
                            backgroundColor: 'primary.white',
                        }}>
                            <ContractDescriptionPanel/>
                            <ContractStatsPanel
                                onCsList={onCsList}
                                onCsfList={onCsfList}
                                onCdpList={onCdpList}
                                onCdpvList={onCdpvList}
                                onCdpvfList={onCdpvfList}
                                onVocabularyList={onVocabularyList}
                                onMarketList={onMarketList}
                            />

                    </Box>}
                {(useSelector((state) => state.contractSectionSlc.value.id) > 0 && selectorHelperState) &&
                    <Box sx={{ ml: '20px' }}>
                    <HelperPanel/>
                    </Box>}
                {(useSelector((state) => state.contractSectionSlc.value.id) > 0 && selectorDynamicHelperState) &&
                    <Box sx={{ ml: '20px' }}>
                        <DynamicHelperPanel/>
                    </Box>}
                {(useSelector((state) => state.contractSectionSlc.value.id) > 0
                        && !selectorHelperState
                        && !selectorDynamicHelperState
                        ) &&
                <Box
                    sx={{
                        width: 1100,
                    height: 300,
                        pl: 3
                    // flexGrow: 5
                }}
                >
                <Box                sx={{
                    // width: 900,
                    // height: 310,
                    // flexGrow: 5,
                    backgroundColor: 'primary.white',
                }}>


                    <Box
                    sx={{
                        // width: 1,
                        height: 310,
                        flexGrow: 5,
                        backgroundColor: 'primary.white',
                    }}
                >

                    <ContractDrilldownCSFGrid selectedSection = {contractSectionIdP}/>
                </Box>
                    <Box sx={{height: 60}} />
                    <Box                    sx={{
                        // width: 1,
                        height: 330,
                        flexGrow: 5,
                        backgroundColor: 'primary.white',
                    }}>
                    {selectorCdpDrawerState  &&
                        <ContractDataPointDrawer/>}
                    <ContractDrilldownCDPGrid

                        selectedSection = {contractSectionIdP}
                        selectorContractId = {selectorContractId}
                        passSelectedCDP = {setSelectedCDPTop}
                        passShowCDPVDrawer = {setShowCDPVDrawerTop}
                        passContractDataPointId={setContractDataPointId}
                    />
                </Box>
            </Box>
                {/*</Stack>*/}
</Box>}
                {/*// *************************** END RIGHT PANEL *******************************************/}
                {/*// ****************************************************************************************/}


            </Stack>


            {/*// *************************** END BODY *************************************************/}
            {/*// ****************************************************************************************/}

            <Box>
            </Box>
            <CrudSnackbar/>
        </div>

    );

    // ****************** END RETURN ****************************

}
